import { CHART_COLOR_PALLETTE } from 'utils/constants';
import { ICellRendererParams, ICurrencyFormat } from 'utils/types';
import {
  cellCurrencyRendererFramework,
  varianceCurrencyCellRendererFramework,
} from '../TableComponents';

const BETWEEN_COLUMNS_WIDTH = 48;
const TITLE_WIDTH = 208;

const column = (
  id: number,
  headerName: string,
  columnDateLabels: string[],
  renderers: {
    regularCellRenderer: (p: ICellRendererParams) => React.ReactNode;
    varianceCellRenderer: (p: ICellRendererParams) => React.ReactNode;
  }
) => ({
  headerName,
  headerGroupComponent: 'customHeaderGroupComponent',
  children: [
    {
      headerName: columnDateLabels[0],
      field: `category${id}CurrYear`,
      type: 'numericColumn',
      headerComponentParams: { color: CHART_COLOR_PALLETTE[0] },
      cellRendererFramework: renderers.regularCellRenderer,
      width: 80,
      sortable: true,
    },
    {
      headerName: columnDateLabels[1],
      field: `category${id}PrevYear`,
      type: 'numericColumn',
      headerComponentParams: { color: CHART_COLOR_PALLETTE[1] },
      cellRendererFramework: renderers.regularCellRenderer,
      width: 80,
      sortable: true,
    },
    {
      headerName: 'CHANGE',
      field: `category${id}Variance`,
      type: 'numericColumn',
      cellRendererFramework: renderers.varianceCellRenderer,
      width: 92,
      sortable: true,
    },
  ],
});

export const getColumnDefs = ({
  columns,
  columnDateLabels,
  format,
}: {
  columns: string[];
  columnDateLabels: string[];
  format: ICurrencyFormat;
}) => {
  if (!columns.length) {
    return [];
  }
  const cellRenderers = {
    regularCellRenderer: (params: ICellRendererParams) =>
      cellCurrencyRendererFramework(params, format),
    varianceCellRenderer: (params: ICellRendererParams) =>
      varianceCurrencyCellRendererFramework(params, format),
  };
  if (columns.length === 3) {
    return [
      {
        headerName: 'VENDOR',
        field: 'title',
        tooltipField: 'title',
        width: TITLE_WIDTH,
        headerComponentParams: { hideIcon: true },
        sortable: true,
      },
      column(1, columns[0], columnDateLabels, cellRenderers),
      {
        headerName: '',
        field: 'emptySpace',
        width: BETWEEN_COLUMNS_WIDTH,
      },
      column(2, columns[1], columnDateLabels, cellRenderers),
      {
        headerName: '',
        field: 'emptySpace',
        width: BETWEEN_COLUMNS_WIDTH,
      },
      column(3, columns[2], columnDateLabels, cellRenderers),
    ];
  }
  if (columns.length === 2) {
    return [
      {
        headerName: 'VENDOR',
        field: 'title',
        width: TITLE_WIDTH,
        headerComponentParams: { hideIcon: true },
        sortable: true,
      },
      column(1, columns[0], columnDateLabels, cellRenderers),
      {
        headerName: '',
        field: 'emptySpace',
        width: BETWEEN_COLUMNS_WIDTH,
      },
      column(2, columns[1], columnDateLabels, cellRenderers),
    ];
  }
  return [
    {
      headerName: 'VENDOR',
      field: 'title',
      width: TITLE_WIDTH,
      headerComponentParams: { hideIcon: true },
      sortable: true,
    },
    column(1, columns[0], columnDateLabels, cellRenderers),
  ];
};

export const useTableData = ({
  columns,
  columnDateLabels,
  format,
}: {
  columns: string[];
  columnDateLabels: string[];
  format: ICurrencyFormat;
}) => {
  return {
    columnDefs: getColumnDefs({
      columns,
      columnDateLabels,
      format,
    }),
  };
};
